import * as React from 'react';

import { HomePage, HomePageParams, HomePageTab } from './model';
import { HomePageView } from './view';
import { AppWrapper } from 'portcall/appwrapper/model';
import { AppWrapperView } from 'portcall/appwrapper/view';
import { Location, LocationParams } from 'lib/componentLocation';
import { IRoute } from 'lib/componentRouter';
import TZDate from 'lib/TZDate';
import { TZUtils } from 'lib/TZUtils';
import { tzmoment } from 'lib/tzmoment';

export const HomePageRoute = (location : Location, homepage : (params : HomePageParams) => HomePage, tzutils : TZUtils, appWrapper : AppWrapper) : IRoute => {
    const model = homepage(inboundParams(location.params, tzutils));
    return {
        view:
            <AppWrapperView model={appWrapper}>
                <HomePageView model={model} />
            </AppWrapperView>,
        reflectState: () => new Location(location.name, outboundParams(model, tzutils))
    };
};

function inboundParams(p : LocationParams, tzutils : TZUtils) : HomePageParams {
    return {
        tab:  'tab'  in p ? +(p['tab'] || 0) : HomePageTab.Movements,
        date: 'date' in p ? tzutils.setTimezoneOffset(new TZDate(p["date"] + "T00:00:00Z"), true) : tzutils.today(),
        port: p['port']
    };
}

function outboundParams(model : HomePage, tzutils : TZUtils) : LocationParams {
    const p = {} as LocationParams;

    if (model.Tab() !== HomePageTab.Movements) p['tab'] = model.Tab() + '';
    if (!TZDate.eq(model.Date(), tzutils.today())) p['date'] = tzmoment(model.Date()).format('YYYY-MM-DD');
    if (model.PortFilter()) p['port'] = model.PortFilter();

    return p;
}


// WEBPACK FOOTER //
// ./apps/portcall/homepage/route.tsx